import { gql } from "@apollo/client";
import { DashboardType } from "gui/BrowseDashboardsPage/api/dashboardItem";
import { DashboardElementFragment } from "lib/types/graphql";

interface DashboardElementType extends DashboardType {
  folder?: {
    id: string;
    color: string;
    icon: string;
    name: string;
  };
}

export function toDashboardElementType(
  dashboard: DashboardElementFragment
): DashboardElementType {
  return {
    id: dashboard.id,
    name: dashboard.name ?? "",
    slug: dashboard.slug,
    created_at: dashboard.created_at,
    updated_at: dashboard.updated_at,
    tags: dashboard.tags ?? [],
    folder: dashboard.folder
      ? {
          id: dashboard.folder.id,
          color: dashboard.folder.color,
          icon: dashboard.folder.icon,
          name: dashboard.folder.name,
        }
      : undefined,
    owner: {
      id: dashboard.owner.id,
      type: dashboard.owner.type,
      handle: dashboard.owner.handle,
      profile_image_url: dashboard.owner.profile_image_url ?? undefined,
    },
    is_private: dashboard.is_private,
    favoriteCount: dashboard.favorites,
    isTrending:
      (dashboard.trending_scores?.score_1h ?? 0) >= 1 ||
      (dashboard.trending_scores?.score_4h ?? 0) >= 2 ||
      (dashboard.trending_scores?.score_24h ?? 0) >= 20,
  };
}

export const DashboardElement = gql`
  fragment DashboardElement on DashboardResult {
    id
    name
    slug
    created_at
    updated_at
    tags
    folder {
      id
      color
      icon
      name
    }
    owner {
      id
      type
      handle
      profile_image_url
    }
    is_private
    favorites

    trending_scores {
      score_1h
      score_4h
      score_24h
      updated_at
    }
  }
`;
